import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { AuthService, OnboardingService } from '@ridango/core/lib/services';
import { OnboardingType } from '@ridango/widgets';
import { HelperService } from './shared/services/helper.service';
import Env from '@ridango/core/env';
import { take } from 'rxjs/operators';

@Injectable()
export class AccessGuard implements CanActivate {
    constructor(
        @Inject('ENV') private env: Env,
        private router: Router,
        private translate: TranslateService,
        private authService: AuthService,
        private onboardingService: OnboardingService,
        public helper: HelperService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.env.ALLOWED_PATHS && this.env.ALLOWED_PATHS.find((path) => state.url.includes(path))) {
            if (
                !this.authService.getLoginStatus() &&
                !!this.env.PRIVATE_PATHS?.find((path) => state.url.includes(path))
            ) {
                this.router.navigate([this.translate.currentLang, 'login']);
            }

            return true;
        }

        if (this.env.SIGN_ON_PAGE) {
            this.router.navigate([this.translate.currentLang, 'login']);
        } else if (this.env.IS_MOBILE_APP) {
            this.appRouting();
        } else {
            if (this.env.DEFAULT_REDIRECT_AFTER_LOGIN && Array.isArray(this.env.DEFAULT_REDIRECT_AFTER_LOGIN)) {
                this.router.navigate([this.translate.currentLang, ...this.env.DEFAULT_REDIRECT_AFTER_LOGIN]);
            } else {
                this.router.navigate([this.translate.currentLang]);
            }
        }
    }

    private appRouting(): void {
        if (
            this.authService.isAccountDeleted &&
            this.env.DEFAULT_REDIRECT_AFTER_ACCOUNT_DELETE &&
            Array.isArray(this.env.DEFAULT_REDIRECT_AFTER_ACCOUNT_DELETE)
        ) {
            this.router.navigate([this.translate.currentLang, ...this.env.DEFAULT_REDIRECT_AFTER_ACCOUNT_DELETE]);
        } else if (this.env.DEFAULT_REDIRECT_AFTER_LOGIN && Array.isArray(this.env.DEFAULT_REDIRECT_AFTER_LOGIN)) {
            this.router.navigate([this.translate.currentLang, ...this.env.DEFAULT_REDIRECT_AFTER_LOGIN]);
        } else if (this.helper.isAllowedPath('/explore')) {
            this.router.navigate([this.translate.currentLang, 'explore']);
        } else if (this.helper.isAllowedPath('/journey-planner')) {
            this.router.navigate([this.translate.currentLang, 'journey-planner']);
        } else {
            this.router.navigate([this.translate.currentLang]);
        }

        if (this.env.ONBOARDING?.ENABLE_ONBOARDING_FLOW) {
            this.checkOnboarding();
        }
    }

    private checkOnboarding(): void {
        this.onboardingService.onboardingStatusValue.pipe(take(1)).subscribe((onboardingStatus: OnboardingType) => {
            if (
                [OnboardingType.STARTED, OnboardingType.ONBOARD_FLOW, OnboardingType.LOGIN_FLOW].includes(
                    onboardingStatus
                )
            ) {
                this.router.navigate([this.translate.currentLang, 'onboarding']);
            }
        });
    }
}
